// app/frontend/lib/languages.ts

// Map language codes to flag emojis for common languages
export const LANGUAGE_FLAGS: Record<string, string> = {
  en: '🇬🇧', es: '🇪🇸', fr: '🇫🇷', de: '🇩🇪', it: '🇮🇹', pt: '🇵🇹', nl: '🇳🇱',
  pl: '🇵🇱', ru: '🇷🇺', uk: '🇺🇦', zh: '🇨🇳', ja: '🇯🇵', ko: '🇰🇷', ar: '🇸🇦',
  hi: '🇮🇳', tr: '🇹🇷', vi: '🇻🇳', th: '🇹🇭', id: '🇮🇩', ms: '🇲🇾', tl: '🇵🇭',
  sv: '🇸🇪', da: '🇩🇰', no: '🇳🇴', fi: '🇫🇮', cs: '🇨🇿', sk: '🇸🇰', hu: '🇭🇺',
  ro: '🇷🇴', bg: '🇧🇬', el: '🇬🇷', he: '🇮🇱', fa: '🇮🇷', bn: '🇧🇩', ta: '🇱🇰',
}

export const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English', es: 'Spanish', fr: 'French', de: 'German', it: 'Italian',
  pt: 'Portuguese', nl: 'Dutch', pl: 'Polish', ru: 'Russian', uk: 'Ukrainian',
  zh: 'Chinese', ja: 'Japanese', ko: 'Korean', ar: 'Arabic', hi: 'Hindi',
  tr: 'Turkish', vi: 'Vietnamese', th: 'Thai', id: 'Indonesian', ms: 'Malay',
  tl: 'Filipino', sv: 'Swedish', da: 'Danish', no: 'Norwegian', fi: 'Finnish',
  cs: 'Czech', sk: 'Slovak', hu: 'Hungarian', ro: 'Romanian', bg: 'Bulgarian',
  el: 'Greek', he: 'Hebrew', fa: 'Persian', bn: 'Bengali', ta: 'Tamil',
}

export function getLanguageFlag(code?: string): string {
  if (!code) return '🌐'
  return LANGUAGE_FLAGS[code] || '🌐'
}

export function getLanguageName(code?: string): string {
  if (!code) return 'Unknown'
  return LANGUAGE_NAMES[code] || code.toUpperCase()
}
